import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../components-v2/Theme/theme';

export const styleSheet = StyleSheet.create({
	popup: {
		maxWidth: 480,
	},
	description: {
		fontSize: 14,
		color: THEME.colors.text.light,
		lineHeight: 1.5,
		margin: '0 0 16px 0',
	},
	warningBox: {
		display: 'flex',
		alignItems: 'flex-start',
		gap: 10,
		padding: 12,
		backgroundColor: THEME.colors.danger.light,
		borderRadius: THEME.common.borderRadius,
		border: `1px solid ${THEME.colors.danger.main}`,
		fontSize: 13,
		color: THEME.colors.danger.dark,
		lineHeight: 1.4,
	},
	actions: {
		display: 'flex',
		justifyContent: 'flex-end',
		gap: 12,
		borderTop: `1px solid ${THEME.colors.border.light}`,
	},
});
